var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('google-logo',{staticClass:"google-logo"}),_c('span',[_vm._v(" Sign in with Google ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }